// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"7e29f35ad828fad6","5345":"7df570821880a75a"}[chunkId] + ".css";
};